import { handleRoute } from "../https";

export const findRecurrentPayments = async ({ companyId, params }) => {
  try {
    const res = await handleRoute({
      method: "get",
      path: `/v1/companies/${companyId}/recurrent-payments?${params}`,
    });
    return res;
  } catch (error) {
    return {};
  }
};

export const findRecurrentPaymentDetail = async ({
  companyId,
  recurrentPaymentId,
}) => {
  try {
    const res = await handleRoute({
      method: "get",
      path: `/v1/companies/${companyId}/recurrent-payments/${recurrentPaymentId}`,
    });
    return res;
  } catch (error) {
    return {};
  }
};

export const sendRecurrentPaymentsReport = async ({ companyId, params }) => {
  try {
    const res = await handleRoute({
      method: "get",
      path: `/v1/companies/${companyId}/recurrent-payments/report?${params}`,
    });
    return res;
  } catch (error) {
    return {};
  }
};
